<div class="section-details">
    <div class="section-header">
        <div class="section-title-container">
            <div class="section-title">
                {{ "assetmanagement.edit-lifecycle-information.title" | transloco }}
            </div>
            <cerrix-instructions-icon
                [instructionText]="
                    'assetmanagement.edit-lifecycle-information.instructionText' | transloco
                "
                [showText]="false"
            ></cerrix-instructions-icon>
        </div>
        <div class="section-subtitle">
            {{ "assetmanagement.edit-lifecycle-information.subTitle" | transloco }}
        </div>
    </div>
    @if (editModel) {
        <div class="section-fields">
            <div class="section-row">
                <app-cerrix-datepicker-group
                    format="dd-MM-yyyy"
                    [placeholder]="
                        'assetmanagement.edit-lifecycle-information.dateInUsePlaceholder'
                            | transloco
                    "
                    [infoText]="
                        'assetmanagement.edit-lifecycle-information.dateInUseInfo' | transloco
                    "
                    [(value)]="editModel.lifecycle.dateInUse"
                    >{{
                        "assetmanagement.edit-lifecycle-information.dateInUseLabel" | transloco
                    }}</app-cerrix-datepicker-group
                >
                <app-cerrix-datepicker-group
                    format="dd-MM-yyyy"
                    [placeholder]="
                        'assetmanagement.edit-lifecycle-information.dateOutOfUsePlaceholder'
                            | transloco
                    "
                    [infoText]="
                        'assetmanagement.edit-lifecycle-information.dateOutOfUseInfo' | transloco
                    "
                    [mustBeAfter]="editModel.lifecycle.dateInUse"
                    [afterErrorMessage]="
                        'assetmanagement.edit-lifecycle-information.dateOutOfUseErrorMessage'
                            | transloco
                    "
                    [(value)]="editModel.lifecycle.dateOutOfUse"
                    >{{
                        "assetmanagement.edit-lifecycle-information.dateOutOfUseLabel" | transloco
                    }}</app-cerrix-datepicker-group
                >
            </div>
        </div>
    }
</div>

<div class="slide-out-footer">
    <cerrix-button
        buttonType="secondary"
        buttonSize="big"
        secondaryColor="filled"
        data-uiid="asset-management-edit-cancel"
        (click)="openUnsavedChangesConfirmDialog()"
    >
        {{ "assetmanagement.detail.cancelButton" | transloco }}
    </cerrix-button>
    <cerrix-button
        buttonType="primary"
        buttonSize="big"
        data-uiid="asset-management-edit-save-section"
        [disabled]="editSaving"
        (click)="editSave()"
    >
        {{ "assetmanagement.detail.editSaveButton" | transloco }}
    </cerrix-button>
</div>

<cerrix-confirm-dialog
    [name]="confirmUnsavedChangesDialogName"
    dataUiid="asset-management-edit-unsaved-changes-confirm"
    icon="warning"
    [title]="'assetmanagement.edit-lifecycle-information.unsavedChangesDialogTitle' | transloco"
    [description]="
        'assetmanagement.edit-lifecycle-information.unsavedChangesDialogDescription' | transloco
    "
    [cancelText]="
        'assetmanagement.edit-lifecycle-information.unsavedChangesDialogCancelText' | transloco
    "
    [confirmText]="
        'assetmanagement.edit-lifecycle-information.unsavedChangesDialogConfirmText' | transloco
    "
    (cancel)="editCancel()"
    (confirm)="editSave()"
    [waitingOnResult]="editSaving"
    [showResultText]="editSaving"
    class="dialog-unsaved-changes-confirm"
>
</cerrix-confirm-dialog>
